import React from "react"
import PropTypes from "prop-types"

class ControllerGpioStatus extends React.Component {
    constructor(props) {
        super(props);
        console.log("localStorage says gpioAutoRefreshInputsDisabled is "+localStorage.getItem('gpioAutoRefreshInputsDisabled'));
        var autoRefreshInputs = true;
        if (localStorage.getItem('gpioAutoRefreshInputsDisabled') == 'true') {
          autoRefreshInputs = false;
        }
        this.scheduledRefreshTime = 0
        this.dirtyRefreshCount = 0;
        // We start with 1000 ms and grow to 5000 ms on retires.  Keep going at 5000 ms after that.
        this.dirtyRefreshMillis = [500, 500, 1000, 1000, 1000, 2000, 5000];
        this.timer = null;
        // this.state.requestedGpioStates.inputs.key/value/notes
        this.state = {
          //requestedGpioStates has array of inputs and outputs, which do not have an adapter type as part of the data structure at all!
          requestedGpioStates: {controller_id: this.props.controller_id, requested_states: {}},
          // actualGpioStates is keyed by adapter name, then by type(input vs ouptut) then by key/value/notes
          actualGpioStates: {},
          // typedNotes is keyed by adapter name, then by type(input vs ouptut) then by key/value/notes
          typedNotes: {}, 
          isLoading: false,
          errorMessage: null,
          autoRefreshInputs: autoRefreshInputs
        };
        this.handleGpioStateChange = this.handleGpioStateChange.bind(this);
    }
    async handleGpioStateChange(gpioName, noteChangeOnly=false) {
        console.log("handle on called for gpio "+gpioName);
        var that = this;
        var currentState = this.requestedValueForGpio(gpioName);
        if (currentState == null) {
          currentState = this.getActualValueForGpio(gpioName);
        }
        var newState = 0;
        console.log("Current gpio state is "+currentState);
        if (noteChangeOnly) {
          console.log("Updating gpio notes rather than changing gpio state becasue noteChagneOnly is "+noteChangeOnly);
          newState = currentState;
        }
        else {
          if (currentState != null) {
            newState = currentState == 1 ? 0: 1;
            console.log("Changing gpio state to "+newState);
          }  
        }
        var requestedGpioStates = {}
        var found = false;
        const adapterKeys = ["esp32_gate_adapter", "tinkerplate_gate_adapter", "shelly_gate_adapter"];
        for (let k = 0; k < adapterKeys.length; k++) {
          const adapterKey = adapterKeys[k];
          requestedGpioStates[adapterKey] = { outputs: [] };
          const adapterStates = this.state.actualGpioStates[adapterKey];
          if (adapterStates && adapterStates.outputs) {
            for (let i = 0; i < adapterStates.outputs.length; i++) {
              if (adapterStates.outputs[i].key == gpioName) {
                requestedGpioStates[adapterKey].outputs[0] = {}
                requestedGpioStates[adapterKey].outputs[0]['key'] = adapterStates.outputs[i].key;
                requestedGpioStates[adapterKey].outputs[0]['value'] = newState;
                const notes = this.getNotesFromState(adapterKey, 'outputs', adapterStates.outputs[i].key)
                requestedGpioStates[adapterKey].outputs[0]['notes'] = notes;
                found = true;
              }
            }
          }
          requestedGpioStates[adapterKey].inputs = [];
          const adapterInputs = this.state.actualGpioStates[adapterKey].inputs;
          if (adapterInputs) {
            for (let i = 0; i < adapterInputs.length; i++) {
              const input = adapterInputs[i];
              const notes = this.getNotesFromState(adapterKey, 'inputs', input.key) || input.notes || ""
              requestedGpioStates[adapterKey].inputs.push({ key: input.key, notes: notes });
            }
          }
        } 
        if (!found) {
          console.log("Warning: Could not find gpio "+gpioName+" in actualGpioStates");
        }
        requestedGpioStates["controller_id"] = this.getControllerId();

        console.log("Submitting new requested gpio states "+JSON.stringify(requestedGpioStates));
        
        that.setState({isLoading: true, errorMessage: null, requestedGpioStates: requestedGpioStates});
        var url = this.props.baseUrl+'/api/v2/gpio_states';
        var responseAfterPromise = null;
        fetch(url, {
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(requestedGpioStates)
          })
          .then(res => {responseAfterPromise = res; return res.json();})
            .then(json => {
              if (responseAfterPromise.status === 200) {
                console.log("Got server response after processing user input "+json);
                var requestedGpioStates = this.state.requestedGpioStates;
                that.setState({actualGpioStates: json, requestedGpioStates: requestedGpioStates, isLoading: false, errorMessage: null});
                that.scheduleRefreshIfNeeded(that.state)
                return Promise.resolve(json)
              }
              var errorMessage = responseAfterPromise.statusText;
              if (json.error) {
                errorMessage = json.error;
              }
              return Promise.reject(new Error(errorMessage))
            })
            .catch(function(error) {
              that.setState({isLoading: false});
              var errorString = ""+error;
            that.setState({isLoading: false, errorMessage: ''+error});
          }); 
    }

    handleAutoRefreshToggle(e) {
      const newValue = e.target.checked;
      console.log("autoRefreshInputs toggled to "+newValue);
      localStorage.setItem('gpioAutoRefreshInputsDisabled', ""+!newValue);
      this.setState({autoRefreshInputs: newValue});
      this.scheduleRefreshIfNeeded(newValue);
    }

    getActualValueForGpio(gpioName) {
      if (this.state.actualGpioStates == null) {
        return null;
      }
      const adapterKeys = ["esp32_gate_adapter", "tinkerplate_gate_adapter", "shelly_gate_adapter"];
      for (let k = 0; k < adapterKeys.length; k++) {
        const adapterKey = adapterKeys[k];
        const adapterStates = this.state.actualGpioStates[adapterKey];
        if (adapterStates && adapterStates.outputs) {
          for (let i = 0; i < adapterStates.outputs.length; i++) {
            var actualGpioName = adapterStates.outputs[i].key; 
            if (actualGpioName == gpioName) {
              return adapterStates.outputs[i].value;
            }
          }
        }
      }

      return null;
    }

    getRequestedValueForGpio(gpioName) {
      const adapterKeys = ["esp32_gate_adapter", "tinkerplate_gate_adapter", "shelly_gate_adapter"];
      if (this.state.requestedGpioStates != null) {
        for (let k = 0; k < adapterKeys.length; k++) {
          const adapterKey = adapterKeys[k];
          const adapterStates = this.state.requestedGpioStates[adapterKey];
          if (adapterStates && adapterStates.outputs) {
            for (let i = 0; i < adapterStates.outputs.length; i++) {
              var requestedGpioName = adapterStates.outputs[i].key; 
              if (requestedGpioName == gpioName) {
                console.log("Found requested value for gpio "+gpioName+" in requestedGpioStates "+JSON.stringify(this.state.requestedGpioStates));
                return adapterStates.outputs[i].value;
              }
            }
          }
        }
      }
      console.log("Could not find requested value for gpio "+gpioName+" in requestedGpioStates "+JSON.stringify(this.state.requestedGpioStates));
      return null;
    }
    
    isDirty(gpioName) {
      let requestedState = this.getRequestedValueForGpio(gpioName);
      if (requestedState == null) {
        return false;
      }
      console.log("Checking dirty for "+gpioName+", actual states are "+JSON.stringify(this.state.actualGpioStates)+", requested states are "+JSON.stringify(this.state.requestedGpioStates));
      let actualState = this.getActualValueForGpio(gpioName);             
      console.log("requested state is "+requestedState+" actual state is "+actualState);
      if (requestedState != null && actualState != null) {
        if (requestedState !=  actualState) {
          console.log("dirty because requested state of "+requestedState+" !=  "+actualState);
          return true;
        }
        else {
          console.log("not dirty because requested state of "+requestedState+" ==  "+actualState);
          return false;
        }
      }
      else {
        console.log("not dirty because requested state is "+requestedState+" and actual state is "+actualState);
      }
      return false;
    }

    isAnythingDirty() {
      if (!this.state.actualGpioStates) {
        return false;
      }

      const adapterKeys = ["esp32_gate_adapter", "tinkerplate_gate_adapter", "shelly_gate_adapter"];
      for (let k = 0; k < adapterKeys.length; k++) {
        const adapterKey = adapterKeys[k];
        const adapterStates = this.state.actualGpioStates[adapterKey];
        if (adapterStates && adapterStates.outputs && adapterStates.outputs.length > 0) {
          for (let i = 0; i < adapterStates.outputs.length; i++) {
            const key = adapterStates.outputs[i].key;
            if (this.isDirty(key)) {
              return true;
            }
          }
        }
      }

      return false;
    }

    scheduleRefreshIfNeeded(autoRefreshInputs) {
        let dirty = this.isAnythingDirty();
        var refreshMillis = 0;
        if (dirty) {
          if (this.dirtyRefreshCount < this.dirtyRefreshMillis.length) {
            refreshMillis = this.dirtyRefreshMillis[this.dirtyRefreshCount];
            this.dirtyRefreshCount++;
            console.log("Refreshing dirty.  Setting dirty refresh count to "+this.dirtyRefreshCount+" and refreshMillis to "+refreshMillis);  
          }
          else {
            refreshMillis = this.dirtyRefreshMillis.at(-1);
            console.log("Refreshing dirty.  with high count of "+this.dirtyRefreshCount);  
          }

          console.log("Scheduling refresh in "+refreshMillis+" millis because something is dirty");
        } 
        else if (autoRefreshInputs) {
          this.dirtyRefreshCount = 0;
          console.log("Refreshing not dirty. Resetting dirty refresh count to "+this.dirtyRefreshCount);
          refreshMillis = this.dirtyRefreshMillis.at(-1);
          console.log("Scheduling refresh in "+refreshMillis+" millis because autoRefreshInputs is true");
        }
        else {
          this.dirtyRefreshCount = 0;
          console.log("Not scheduling refresh because autoRefreshInputs is false and nothing is dirty");
          console.log("Resetting dirty refresh count to "+this.dirtyRefreshCount);
        }
        if (refreshMillis > 0) {
          this.scheduledRefreshTime = Date.now() + refreshMillis;
        }
        else {
          console.log("Not scheduling refresh because autoRefreshInputs is false and nothing is dirty");
          this.scheduledRefreshTime = 0;
        }
    }


    requestedValueForGpio(gpioName) {
      if (this.state.requestedGpioStates != null && this.state.requestedGpioStates.outputs != null) {
        for (let i = 0; i < this.state.requestedGpioStates.outputs.length; i++) {
          var requestedGpioName = this.state.requestedGpioStates.outputs[i].key; 
          if (requestedGpioName == gpioName) {
            return this.state.requestedGpioStates.outputs[i].value;
          }
        }
      }
      return null;
    }

    updateNotesInState(e, adapterKey, type, gpioName) {
      const newNotes = e.target.value;
      var typedNotes = this.state.typedNotes || {};
      typedNotes[adapterKey] = typedNotes[adapterKey] || {};
      typedNotes[adapterKey][type] = typedNotes[adapterKey][type] || {};
      typedNotes[adapterKey][type][gpioName] = newNotes;
      console.log("Updating typed notes in state for "+adapterKey+" "+type+" "+gpioName+" to be "+newNotes);
      console.log("typedNotes is now "+JSON.stringify(typedNotes));
      this.setState({typedNotes: typedNotes});
    }
    getNotesFromState(adapterKey, type, gpioName) {
      if (this.state.typedNotes && this.state.typedNotes[adapterKey] && this.state.typedNotes[adapterKey][type]) {
        return this.state.typedNotes[adapterKey][type][gpioName] || "";
      }
    }

  render() {
    console.log("Rendering");
    var main_table_rows = [];
    const that = this;
    var header = "GPIO Status Loading...";
    if (this.state.errorMessage) {      
      header = "Error Loding Data: " + this.state.errorMessage;
    }
    else if (this.state.actualGpioStates) {
      header = (<h3>Auto refresh inputs &nbsp;
        <label className="switch">
          <input type="checkbox" onChange={this.handleAutoRefreshToggle.bind(this)} checked={this.state.autoRefreshInputs} />
          <span className={"slider round"}></span>
        </label>
      </h3>)
      const adapterKeys = ["esp32_gate_adapter", "tinkerplate_gate_adapter", "shelly_gate_adapter"];

      // Build rows for each configured adapter type
      adapterKeys.forEach((adapterKey) => {
        const adapterStates = this.state.actualGpioStates[adapterKey]
        if (adapterStates && adapterStates.outputs && adapterStates.outputs.length > 0) {
          console.log("gpio states for " + adapterKey + " are " + JSON.stringify(adapterStates.outputs));

          // Adapter header row spanning all columns
          main_table_rows.push(
            <tr key={adapterKey + "_header"}>
              <td colSpan="3" style={{ borderBottom: "2px solid #ccc" }}>{adapterKey.replace(/_/g, " ").toUpperCase()}</td>
            </tr>
          )

          adapterStates.outputs.forEach((output) => {
            const key = output.key
            var gpioState = output.value

            var notes = this.getNotesFromState(adapterKey, 'outputs', key) || output.notes || ""
            var status = gpioState == 1 ? 1 : 0
            var dirty = this.isDirty(key)
            if (dirty) {
              status = (status == 0) ? 1 : 0 // Flip the state for display purposes if dirty 
              console.log("Dirty gpio "+key+" has requested state of "+this.getRequestedValueForGpio(key)+" and actual state of "+this.getActualValueForGpio(key)); 
            }
            console.log("Rendering switch for gpio "+key+" with gpioState "+gpioState+", display status "+status+" and notes "+notes+" and dirty "+dirty);

            var switchControl = (
              <label className="switch">
                <input type="checkbox" onChange={this.handleGpioStateChange.bind(this, key, false)} checked={status == 1} />
                <span className={"slider round" + (dirty ? ' dirty' : '')}></span>
              </label>
            )

            var controlCell = (
              <td>{switchControl}</td>
            )

            main_table_rows.push(
              <tr key={key}>
                <td>{key}</td>
                {controlCell}
                <td>
                  <input type="text" onChange={(e) => this.updateNotesInState(e, adapterKey, 'outputs', key)} value={notes} style={{ border: "1px solid #ccc", borderRadius: "4px", padding: "4px", width: "80%" }} />
                  &nbsp;
                  <button onClick={this.handleGpioStateChange.bind(this, key, true)} style={{ padding: "4px" }}>Save</button>
                </td>
              </tr>
            )
          })
        }
      })

      // Fallback for legacy flat outputs if no adapter-specific outputs are present
      if (main_table_rows.length === 0 && this.state.actualGpioStates.outputs && this.state.actualGpioStates.outputs.length > 0) {
        console.log("gpio states are " + JSON.stringify(this.state.actualGpioStates.outputs));

        main_table_rows.push(
          <tr key="default_header">
            <td colSpan="3" style={{ borderBottom: "1px solid #ccc" }}>GPIO OUTPUTS</td>
          </tr>
        )

        for (let i = 0; i < this.state.actualGpioStates.outputs.length; i++) {
          const key = this.state.actualGpioStates.outputs[i].key;
          const gpioState = this.state.actualGpioStates.outputs[i].value;
          var status = this.requestedValueForGpio(key);
          if (status == null) {
            status = gpioState || 0;
          }
          var dirty = this.isDirty(key)
          var spinner = ""

          var pulldown = (
            <select onChange={this.handleGpioStateChange.bind(this, key, false)} value={status}>
              <option value="0" defaultValue>OFF</option>
              <option value="1">ON</option>
            </select>
          )

          if (dirty) {
            spinner = (<img className="spinner" src="/assets/spinner.gif" />)
          }
          var row = (
            <tr key={key}>
              <td>{key}</td>
              <td>{pulldown}&nbsp;{spinner}</td>
              <td></td>
            </tr>
          );
          main_table_rows.push(row)
        }
      }

      // Build rows for GPIO inputs section (read-only OFF/ON per adapter)
      var inputs_table_rows = [];
      adapterKeys.forEach((adapterKey) => {
        const adapterStates = this.state.actualGpioStates[adapterKey];
        if (adapterStates && adapterStates.inputs && adapterStates.inputs.length > 0) {
          inputs_table_rows.push(
            <tr key={adapterKey + "_inputs_header"}>
              <td colSpan="3" style={{ borderBottom: "1px solid #ccc" }}>{adapterKey.replace(/_/g, " ").toUpperCase()}</td>
            </tr>
          );
          adapterStates.inputs.forEach((input) => {
            const key = input.key;
            const value = input.value;
            const notes = this.getNotesFromState(adapterKey, 'inputs', key) || input.notes || ""

            const stateLabel = value === 1 ? "ON" : "OFF";
            inputs_table_rows.push(
              <tr key={adapterKey + "_" + key}>
                <td>{key}</td>
                <td>{stateLabel}</td>
                <td>
                  <input type="text" onChange={(e) => this.updateNotesInState(e, adapterKey, 'inputs', key)} value={notes} style={{ border: "1px solid #ccc", borderRadius: "4px", padding: "4px", width: "80%" }} />
                  &nbsp;
                  <button onClick={this.handleGpioStateChange.bind(this, key, true)} style={{ padding: "4px" }}>Save</button>
                </td>
              </tr>
            );
          });
        }
      });

      // Fallback for legacy flat inputs if no adapter-specific inputs are present
      if (inputs_table_rows.length === 0 && this.state.actualGpioStates.inputs && this.state.actualGpioStates.inputs.length > 0) {
        inputs_table_rows.push(
          <tr key="default_inputs_header">
            <td colSpan="3" style={{ borderBottom: "2px solid #444" }}><span style={{ fontWeight: "bold" }}>GPIO Input</span></td>
          </tr>
        );
        this.state.actualGpioStates.inputs.forEach((input) => {
          const key = input.key;
          const value = input.value;
          const stateLabel = value === 1 ? "ON" : "OFF";
          inputs_table_rows.push(
            <tr key={key}>
              <td>{key}</td>
              <td>{stateLabel}</td>
              <td></td>
            </tr>
          );
        });
      }

      // Combine outputs and inputs into one table; inputs section has a heading row
      var all_table_rows = main_table_rows.slice();
      if (inputs_table_rows.length > 0) {
        // Add section heading only for per-adapter inputs (legacy inputs already have "GPIO INPUTS" as first row)
        var hasPerAdapterInputs = adapterKeys.some((k) => {
          const s = this.state.actualGpioStates[k];
          return s && s.inputs && s.inputs.length > 0;
        });
        if (hasPerAdapterInputs) {
          all_table_rows.push(
            <tr key="inputs_section_spacer">
              <td colSpan="3" style={{ height: "12px" }}></td>
            </tr>
          );
          all_table_rows.push(
            <tr key="inputs_section_header">
              <td style={{ fontWeight: "bold", borderBottom: "2px solid #444" }}>GPIO Input</td>
              <td style={{ fontWeight: "bold", borderBottom: "2px solid #444" }}>Status</td>
              <th style={{ fontWeight: "bold", borderBottom: "2px solid #444" }}>Notes</th>
            </tr>
          );
        }
        all_table_rows.push(...inputs_table_rows);
      }

      if (main_table_rows.length > 0) {
        return (
          <React.Fragment>
            <div id="controller_tunnel">
              {header}
              <table className="main_table">
                <thead>
                  <tr>
                    <th style={{ borderBottom: "2px solid #444" }}>GPIO Output</th>
                    <th style={{ borderBottom: "2px solid #444" }}>Control</th>
                    <th style={{ borderBottom: "2px solid #444" }}>Notes</th>
                  </tr>
                </thead>
                <tbody>
                  {all_table_rows}
                </tbody>
              </table>
            </div>
          </React.Fragment>
        );
      }

      // No GPIO adapters configured case
      return (
        <React.Fragment>
          <div id="controller_tunnel" className={this.state.isLoading ? "loading" : "done-loading"}>
            No GPIO adapters are configured on the lane controller.
          </div>
        </React.Fragment>
      );
    }

    return (
      <React.Fragment>
        <div id="tag_reads" className={this.state.isLoading ? "loading" : "done-loading"}>
          {header}
        </div>
      </React.Fragment>
    );
  }
    
    componentDidMount() {
      console.log("componentDidMount called for ControllerGpioStatus");
      console.log("autoRefreshInputs is "+this.state.autoRefreshInputs);
        this.fetchGpioStates();
        setInterval(function() {               
          if (this.scheduledRefreshTime > 0) {
            if (Date.now() < this.scheduledRefreshTime) {
              //console.log("Not time to refresh yet until "+this.scheduledRefreshTime+" (in "+(this.scheduledRefreshTime-Date.now())+" millis), so rescheduling");
              return;
            }               
            this.fetchGpioStates()
          }
          else {
            //console.log("Not refreshing because scheduledRefreshTime is 0");
          }
        }.bind(this), 100); 
    }
    
    getControllerId() {
      console.log("controller id is "+this.props.controller_id);
      return  this.props.controller_id; 
    }
    
    fetchGpioStates() {    
        var that = this;
        var url = this.props.baseUrl+'/api/v2/gpio_states';
        var responseAfterPromise = null;
        fetch(url, {
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({controller_id: this.getControllerId()})
        })
          .then(res => {responseAfterPromise = res.clone(); return res.json();})
            .then(json => {
              if (responseAfterPromise.status === 200) {
                var requestedGpioStates = this.state.requestedGpioStates;
                var shouldReplaceRequest = false;
                if (shouldReplaceRequest) {
                  requestedGpioStates = json;   
                  requestedGpioStates["controller_id"] = this.getControllerId();                  
                }
                console.log("After update requestedGpioStates is "+JSON.stringify(requestedGpioStates));
                console.log("After update actualGpioStates is "+JSON.stringify(json));
                if (json) {
                  that.setState({actualGpioStates: json, requestedGpioStates: requestedGpioStates, isLoading: false, errorMessage: null});
                }
                that.scheduleRefreshIfNeeded(that.state.autoRefreshInputs)
                return Promise.resolve(json)
              }
              var errorMessage = responseAfterPromise.statusText;
              if (json.error) {
                errorMessage = json.error;
              }
              return Promise.reject(new Error(errorMessage))
            })
            .catch(function(error) {
              responseAfterPromise.text().then((txt) => console.log(`Status code: ${responseAfterPromise.status} status message: ${responseAfterPromise.statusText} Body: ${txt}`));
              var errorString = ""+error;
              console.log(error)	      
            that.setState({controller_tunnels: [], isLoading: false, errorMessage: ''+error});
        });
    }
}

ControllerGpioStatus.propTypes = {
  greeting: PropTypes.string
};
export default ControllerGpioStatus
